import { ANALYTICS_KEYS, TerminationReason } from '@/types';
import { useAnalyticContext } from '@/modules/analytic/providers/AnalyticProvider';
import { SearchTypes } from '@/types/search';
import { useCallback } from 'react';

interface TrackSearchProps {
  value: string;
  terminationReason?: TerminationReason | SearchTypes;
  contentUUID?: string;
}

export const useTrackSearch = () => {
  const { track } = useAnalyticContext();

  const trackSearch = useCallback(
    ({ value, terminationReason, contentUUID }: TrackSearchProps) => {
      track(
        ANALYTICS_KEYS.SEARCH,
        {
          typed_query: value,
          source: 'top',
          termination_reason: terminationReason || TerminationReason.Leave,
          contentUUID,
        },
        true
      );
    },
    [track]
  );

  return { trackSearch };
};
